import post from './post.js';
import get from './get.js';

export default {
	data: ({session}) => get('440/data',{session}),
	delete: ({ session, ip, name }) => post('440/delete', { session, ip, name }),
	delete_all: ({ session, ip }) => post('440/delete_all', { session, ip })
};
